import styled from "styled-components";
import Tooltip from "react-bootstrap/Tooltip";

export const PageContainer = styled.div`
  width: 100%;
  padding: 20px 50px 50px 50px;
  font-family: 'Montserrat';

  @media only screen and (max-width: 700px) {
    padding: 20px 10px 10px 10px;
  }

  .customAlert > p {
    margin-bottom: 0;
  }

  .credit-available {
    background-color: #E8FC8B;
  }

  .credit-available .badge-label {
    color: #192619 !important;
  }

  .credit-available .badge-value {
    color: #192619 !important;
  }
`;

export const Subcontainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1600px;
  width: 100%;
  margin: auto;
  margin-top: 20px;
  gap: 20px;

  @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
`;

export const HomeHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin: 1rem 0 0 0;
  
  &.filter-container {
    @media only screen and (max-width: 700px) {
      flex-direction: column;
      align-items: stretch;
    }
  }

  @media only screen and (max-width: 700px) {
    padding-left: 0px;
    margin: 0.5rem 0;
  }
  
  .card-grid-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    
    @media only screen and (max-width: 700px) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
    }
  }
`

export const UserAlertBadge = styled.div`
  background: #192619;
  margin: 0px;
  padding: 8px 12px;
  border-radius: 8px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 0.2s ease;
  box-sizing: border-box;

  &.flex-row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-width: 300px;
    flex-wrap: nowrap;
    
    @media only screen and (max-width: 768px) {
      min-width: 100%;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: flex-start;
    }
    
    @media only screen and (max-width: 700px) {
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      padding: 10px 12px;
    }
  }
  
  &.card-grid-item {
    flex: 1 1 0;
    min-width: 0;
    
    @media only screen and (max-width: 700px) {
      min-width: unset;
      width: 100%;
      height: auto;
      min-height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: none;
    }
  }

  .badge-label {
    font-size: 0.9rem;
    color: #758B78;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    
    i {
      font-size: 1rem;
      color: white;
      flex-shrink: 0;
    }
  }

  .badge-value {
    font-size: 1.1rem;
    color: white;
    font-weight: 600;
    text-align: left;
    word-break: break-word;
  }

  @media only screen and (max-width: 700px) {
    min-width: 100px;
    padding: 8px 10px;

    .badge-label {
      font-size: 0.75rem;
    }

    .badge-value {
      font-size: 1rem;
    }
  }
  
  /* Safari iOS gap fallback for versions below 14.5 */
  @supports (-webkit-touch-callout: none) and (not (translate: none)) {
    gap: 0;
    
    > * {
      margin-bottom: 4px;
    }
    
    > *:last-child {
      margin-bottom: 0;
    }
    
    &.flex-row {
      > * {
        margin-bottom: 0;
        margin-right: 8px;
      }
      
      > *:last-child {
        margin-right: 0;
      }
      
      @media only screen and (max-width: 768px) {
        > * {
          margin-right: 8px;
          margin-bottom: 4px;
        }
        
        > *:last-child {
          margin-right: 0;
          margin-bottom: 0;
        }
      }
    }
    
    .badge-label {
      gap: 0;
      
      i {
        margin-right: 6px;
      }
    }
  }
  
  /* Safari-specific fixes */
  @supports (-webkit-appearance: none) {
    -webkit-box-sizing: border-box;
    
    &.flex-row {
      -webkit-flex-direction: row;
      -webkit-align-items: center;
      -webkit-justify-content: space-between;
      
      @media only screen and (max-width: 700px) {
        -webkit-flex-wrap: wrap;
      }
    }
  }
`

export const CardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media only screen and (max-width: 700px) {
    width: 100%;
    padding: 0px;
    margin-top: 5px;
  }
`

export const MoneyChangeBadge = styled.span`
  padding: 3px 5px;
  font-size: 0.8rem;
  margin-left: 5px;
  background-color: ${props => props.pendingPayments >= 0 ? "#94E5AB" : "#A33"};
  color: ${props => props.pendingPayments >= 0 ? "#1C2D1C" : "white"};
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  
  @media only screen and (max-width: 700px) {
    font-size: 0.75rem;
    padding: 2px 4px;
    margin-left: 3px;
  }
`

export const NameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #192619;
  padding: 4.5px;
  border-radius: 5px;
  padding-right: 10px;
`

export const NameSearchContainer = styled.div`
  width: 200px;

  input {
    background-color: #192619;
    border: 0px;
    color: white;

    ::placeholder {
      color: white;
      opacity: 0.6;
    }
  }
`;

export const WarningBanner = styled.div`
  background-color: #fff3cd;
  color: #856404;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
  border: 1px solid #ffeeba;
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    transition: all 0.2s;
    font-weight: 500;
    
    &:first-of-type {
      color: #2563eb;
      text-decoration: underline;
      
      &:hover {
        color: #1d4ed8;
      }
    }
    
    &:last-of-type {
      background-color: #16a34a;
      color: white;
      padding: 0.25rem 1rem;
      border-radius: 0.375rem;
      
      &:hover {
        background-color: #15803d;
      }
    }
  }

  .flex {
    display: flex;
  }

  .items-center {
    align-items: center;
  }

  .justify-between {
    justify-content: space-between;
  }

  .w-full {
    width: 100%;
  }

  .gap-4 {
    gap: 1rem;
  }

  .mr-2 {
    margin-right: 0.5rem;
  }
`;

export const LoadingLine = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(to right, #E8FC8B, #4CAF50);
  z-index: 9999;
  animation: loading 2s ease-in-out forwards;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;

  @keyframes loading {
    0% {
      transform: scaleX(0);
      opacity: 1;
    }
    50% {
      transform: scaleX(1);
      opacity: 1;
    }
    100% {
      transform: scaleX(0);
      opacity: 0;
    }
  }
`;

export const HeaderCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  /* Safari-specific rendering optimizations */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  & .user-card-group {
    flex: 0 0 auto;
    min-width: 300px;
  }

  @media only screen and (min-width: 700px) and (max-width: 1300px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  @media only screen and (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    & .user-card-group {
      width: 100%;
      min-width: unset;
      flex: none;
    }
  }
  
  /* Safari iOS gap fallback for versions below 14.5 */
  @supports (-webkit-touch-callout: none) and (not (translate: none)) {
    gap: 0;
    
    > * {
      margin-bottom: 20px;
    }
    
    > *:last-child {
      margin-bottom: 0;
    }
    
    @media only screen and (max-width: 700px) {
      > * {
        margin-bottom: 10px;
      }
      
      > *:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const CardsGroup = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
  /* Safari-specific rendering optimizations */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  > * {
    flex: 1 1 0;
    min-width: 120px;
  }

  @media only screen and (min-width: 700px) and (max-width: 1300px) {
    width: 100%;
    flex: none;
  }

  @media only screen and (max-width: 700px) {
    width: 100%;
    flex: none;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    
    > * {
      flex: none;
      min-width: unset;
    }
  }
  
  /* Safari iOS gap fallback for versions below 14.5 */
  @supports (-webkit-touch-callout: none) and (not (translate: none)) {
    gap: 0;
    
    > * {
      margin-right: 10px;
    }
    
    > *:last-child {
      margin-right: 0;
    }
    
    @media only screen and (max-width: 700px) {
      /* On mobile grid, use margin fallback */
      gap: 0;
      grid-gap: 8px; /* Fallback for older grid implementations */
      
      > * {
        margin-right: 0;
        margin-bottom: 8px;
      }
      
      > *:nth-child(2n) {
        margin-right: 0;
      }
      
      > *:nth-last-child(-n+2) {
        margin-bottom: 0;
      }
    }
  }
  
  /* Safari-specific grid fixes */
  @supports (-webkit-appearance: none) {
    @media only screen and (max-width: 700px) {
      display: -webkit-grid;
      display: grid;
      -webkit-grid-template-columns: repeat(2, 1fr);
      grid-template-columns: repeat(2, 1fr);
      -webkit-grid-gap: 8px;
      grid-gap: 8px;
    }
  }
`;

export const CreditTooltip = styled(Tooltip)`
  .tooltip-inner {
    max-width: 350px;
    padding: 0.75rem;
    background-color: #1B2D1A;
    color: #FFFFFF;
    font-size: 0.875rem;
    line-height: 1.4;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    text-align: left;
  }

  .tooltip-arrow::before {
    border-top-color: #1B2D1A;
    border-bottom-color: #1B2D1A;
  }
`;